import { Link } from 'react-router-dom';
import { mangaList, hotMangaIds } from '@/mocks/manga';

export default function HotRanking() {
  const hot = hotMangaIds.map((id) => mangaList.find((m) => m.id === id)!);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100" data-product-shop="">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最受读者欢迎的漫画排行榜</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {hot.map((manga, index) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}/1`}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer group"
            >
              {/* Rank Badge */}
              <div className="relative shrink-0">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full text-sm font-bold ${
                  index === 0
                    ? 'bg-accent-500 text-background-50'
                    : index === 1
                    ? 'bg-secondary-400 text-background-50'
                    : index === 2
                    ? 'bg-primary-400 text-background-50'
                    : 'bg-secondary-100 text-secondary-600'
                }`}>
                  {index + 1}
                </div>
              </div>

              {/* Cover */}
              <div className="w-14 h-[74px] rounded overflow-hidden shrink-0">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover object-top"
                  width="56"
                  height="74"
                />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">{manga.author}</p>
                <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                    {manga.rating}
                  </span>
                  <span>{manga.chapters}话</span>
                  <span className="hidden sm:inline">{manga.status}</span>
                </div>
              </div>

              {/* View Count */}
              <div className="hidden sm:flex flex-col items-end shrink-0">
                <span className="text-sm font-medium text-primary-500">
                  {(manga.views / 10000).toFixed(0)}万
                </span>
                <span className="text-xs text-foreground-400">人气</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}